import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { SIDEMENU } from "../../databucket";
import { DAYNAMIC_ROUTES, GET_DYNAMIC_ROUTES } from "../../Queries/options";
import { useMutation, useQuery } from "@apollo/client";
import { setLoader } from "../../Slices/loaderSlice";
import { updateSidebarData } from "./updateSidebarData";
import { message } from "antd";
import { getOptionsByPath } from "../../utilsdata";

import { AntdButton, CheckboxField, SelectInput } from "../../blueplanitUtils/InputField";
import { ADD_EDIT_EMPLOYEE, DYNAMIC_ROUTES, DYNAMIC_ROUTES_ROLE, EMPLOYEE_DEPARTMENT } from "../../Dropdownmanager";

const ConditionMenuRoute = () => {
  const [submitState, setSubmitState] = useState(false);
  const [department, setDepartment] = useState(null);
  const [name, setName] = useState(null);
  const [sidemenu, setSidemenu] = useState(SIDEMENU);
  const [openDepartment, setOpenDepartment] = useState(false);
  const [SideMENU] = useMutation(DAYNAMIC_ROUTES);
  const dispatch = useDispatch();
  const loginUserRole = useSelector((state) => state?.loginUserInfo?.loginUserDetails.role);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);


  const { data, refetch } = useQuery(GET_DYNAMIC_ROUTES, {
    onCompleted: (data) => {
    },
    onError: (error) => {

    },
  });

  const handleDepartmentChange = (value) => {
    setDepartment(value);
    setOpenDepartment(false); // Close dropdown after selection
  };

  const handleNameChange = (value) => {
    setName(value);
  };
  useEffect(() => {
    if (data && data.getSideMenu) {
      const foundItem = data.getSideMenu.find(
        (item) => item.name === name && item.department === department
      );
      if (foundItem) {
        const mergedData = updateSidebarData(SIDEMENU, foundItem.fields);
        setSidemenu(mergedData);
      } else {
        setSidemenu(SIDEMENU);

      }
    }
  }, [name, department, data]);

  const handleSubmit = async () => {
    setSubmitState(true);

    // Role restriction logic
    const roleHierarchy = {
      "User": 1,
      "Admin": 2,
      "Super Admin": 3,
    };

    if (!name || !department) {
      message.error("Please select both department and role.");
      setSubmitState(false);
      return;
    }

    if (roleHierarchy[loginUserRole] < roleHierarchy[name]) {
      message.error("You are not authorized to update this role's routes.");
      setSubmitState(false);
      return;
    }

    const formattedData = {
      name: name,
      department: department,
      fields: sidemenu?.map((menu) => ({
        name: menu.name,
        status: menu.status,
        mainId: menu.mainId,
        Subfields: menu.Subfields?.map((sub) => ({
          displayName: sub.displayName,
          subId: sub.subId,
          name: sub.name,
          status: sub.status,
        })) || [],
      })),
    };



    try {
      dispatch(setLoader(true))
      const { data } = await SideMENU({ variables: { input: formattedData } });

      if (data?.SideMENU?.status) {
        dispatch(setLoader(false))
        message.success({
          content: data?.SideMENU?.message,
          duration: 5, // Toast will disappear after 5 seconds
          className: 'custom-toast-center', // Custom class to center the toast
        });
        await refetch();
      }

    } catch (error) {
      dispatch(setLoader(false))
      message.error({
        content: error,
        duration: 5, // Toast will disappear after 5 seconds
        className: 'custom-toast-center', // Custom class to center the toast
      });

    } finally {
      setSubmitState(false)
      dispatch(setLoader(false))
      setSubmitState(false);
    }

    setSubmitState(false);
  };

  const handleParentCheckboxChange = (index) => {
    setSidemenu((prevMenu) =>
      prevMenu.map((menu, i) =>
        i === index
          ? {
            ...menu,
            status: !menu.status,
            Subfields: menu.Subfields.map((subfield) => ({
              ...subfield,
              status: !menu.status,
            })),
          }
          : menu
      )
    );
  };

  const handleSubfieldCheckboxChange = (parentIndex, subIndex) => {
    setSidemenu((prevMenu) =>
      prevMenu.map((menu, i) =>
        i === parentIndex
          ? (() => {
            // Toggle subfield status first
            const updatedSubfields = menu.Subfields.map((subfield, j) =>
              j === subIndex ? { ...subfield, status: !subfield.status } : subfield
            );

            // Check if all subfields are now false
            const allSubfieldsFalse = updatedSubfields.every(sub => !sub.status);

            return {
              ...menu,
              Subfields: updatedSubfields,
              status: allSubfieldsFalse ? false : menu.status, // If all false, uncheck main route
            };
          })()
          : menu
      )
    );
  };


  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div id="document_manager" style={{ display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
          <div
            className="card-body"
            style={{
              margin: "0 auto",
              padding: "20px",
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              maxWidth: "100%",
              width: "90%",
            }}
          >
            <h2 style={{ marginBottom: "20px", textAlign: "center", font: "bold" }}>Manage Routes and Sidemenu</h2>

            <div style={{ padding: "20px", background: "#fff", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "8px" }}>
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div style={{ marginBottom: "15px" }}>
                  <SelectInput
                    label="Select Department:"
                    value={department}
                    open={openDepartment}
                    onDropdownVisibleChange={(open) => setOpenDepartment(open)}
                    style={{ width: 200 }}
                    onChange={handleDepartmentChange}
                    options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}

                  />
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <SelectInput
                    label="Select Role:"
                    style={{ width: 200 }}
                    onChange={handleNameChange}
                    options={getOptionsByPath(NestedDatabucket, [DYNAMIC_ROUTES, DYNAMIC_ROUTES_ROLE])}
                  />
                </div>
              </div>

              <Collapse
                items={sidemenu?.map((menu, index) => ({
                  key: menu.id || menu.name || index,
                  label: (
                    <CheckboxField
                      name={`menu-${menu.id || index}`}
                      checked={menu.status}
                      onChange={() => handleParentCheckboxChange(index)}
                      style={{ fontFamily: "serif", fontSize: "16px" }}
                      label={menu.name}
                    />
                  ),
                  children: (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                      {menu.Subfields?.map((sub, subIndex) => (
                        <div
                          key={sub.id || sub.displayName || subIndex}
                          style={{
                            maxWidth: "200px",
                            padding: "5px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <CheckboxField
                            checked={sub.status}
                            disabled={!menu.status}
                            onChange={() => handleSubfieldCheckboxChange(index, subIndex)}
                            label={sub.displayName}
                          />
                        </div>
                      ))}
                    </div>
                  ),
                }))}
              />

            </div>

            <AntdButton
              type="primary"
              onClick={handleSubmit}
              style={{
                marginTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              disabled={submitState}
              label="Submit"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionMenuRoute;
